import React, { useEffect } from 'react';
import '../styles/SnackBar.css';

export default function Snackbar({ open, onClose, duration = 500, children }) {
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      onClose && onClose();
    }, duration);
    return () => clearTimeout(t);
  }, [open, duration, onClose]);

  if (!open) return null;

  return (
    <div className="snackbar-container" role="status" aria-live="polite">
      <div className="snackbar-box">
        <div className="snackbar-content">{children}</div>
        <div className="snackbar-actions">
          <button className="snackbar-btn" onClick={onClose}>X</button>
        </div>
       
      </div>
    </div>
  );
}
